import React, {useEffect, useState, useRef} from 'react';
import Highcharts from 'highcharts';
import {NodeExpandOutlined, RightOutlined} from '@ant-design/icons';
import {Row, Col, Tabs, Table, Divider, Tooltip} from 'antd';
import useDataContext from '../../context/useDataContext';
import moment from 'moment';
import 'moment/locale/es';

const { TabPane } = Tabs;

const GraficasPJ = (props) => {

    const { graficaPorPoderes, 
            setGraficaPorPoderes,
            graficaPorCandidatura, 
            setGraficaPorCandidatura
          } = useDataContext();

    const [selectedKey, setSelectedKey] = useState('1');
    const [continuar, setContinuar] = useState(false);


    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    useEffect(() => {

        if(Number(selectedKey) === 1 && continuar){
            renderizaGraficaUno();
        }
        if(Number(selectedKey) === 2 && continuar){
            renderizaGraficaDos();
        }

    }, [selectedKey, continuar]);

    useEffect(() => {

		if (graficaPorPoderes?.grafica && graficaPorCandidatura?.grafica){
			
            setContinuar(true);

		}

    }, [graficaPorPoderes,graficaPorCandidatura]);

    const renderizaGraficaUno = async() => {

        let newOrdenSeries = [
                    graficaPorPoderes.grafica.series[1],
                    graficaPorPoderes.grafica.series[0],
                ];

        let newOrdenColors = [
                    graficaPorPoderes.grafica.colores_series[1],
                    graficaPorPoderes.grafica.colores_series[0],
                ];

        let newOrdenSerieLabels = [
                    graficaPorPoderes.grafica.nombres_series[1],
                    graficaPorPoderes.grafica.nombres_series[0],
                ];
                
        let series = newOrdenSeries.map((data, index) => {
            const serie = {
                data: data,
                color: newOrdenColors[index]  // Asignamos el color correspondiente
            };
    
            // Si deshabilitarName es false, asignamos el nombre, de lo contrario lo omitimos
            if (!graficaPorPoderes.grafica.deshabilitarName[index]) {
                serie.name = newOrdenSerieLabels[index]; // Asignamos el nombre a la serie
            }
    
            return serie;
        });

        let chartConfig = {
            title: {
                text: graficaPorPoderes.grafica.titulo,
            },
            xAxis: {
                categories: graficaPorPoderes.grafica.labels_x,
            },
            chart: {
                borderWidth: 0,  // Elimina el borde alrededor de la gráfica
                backgroundColor: '#F8FBFF !important',  // Establece el fondo transparente
            },
            legend: {
                enabled: true,  // Habilitamos la leyenda
                layout: 'horizontal',  // Esto asegura que los labels estén en una fila
                align: 'center',  // Centra la leyenda
                verticalAlign: 'top',  // Coloca la leyenda en la parte superior
                borderWidth: 0,  // Sin borde para la leyenda
                itemStyle: {
                    fontWeight: 'bold',  // Hace los nombres de la leyenda más prominentes
                    fontSize: '14px',  // Ajusta el tamaño de la fuente si es necesario
                },
            },
            tooltip: {
                backgroundColor: '#FFFFFF',  // Establece el fondo del tooltip a blanco
                shadow: true,  // Activa la sombra en el tooltip
                pointFormatter: function() {
                    return `<b>${this.y}%</b>`;  // Agrega un '%' al valor mostrado en el tooltip
                },
            },
            yAxis: {
                min: graficaPorPoderes.grafica.minimo,
                max: graficaPorPoderes.grafica.maximo?? 100,
                title: {
                    text: "Porcentaje",
                },
                //tickInterval: 20,
            },
            series: series,  // Usamos las series generadas dinámicamente
            credits: {
                enabled: false, // Esto desactiva la marca de agua de Highcharts
            },
        };

        await sleep(200); 

        Highcharts.chart('graficaUno', {
            ...chartConfig,
            chart: {
                type: 'bar',  // Tipo de gráfico: barras
                renderTo: 'graficaUno',
            },
        });
    };

    const renderizaGraficaDos = async() => {

        let newOrdenLabels = [
                                graficaPorCandidatura.grafica.labels_x[0],
                                graficaPorCandidatura.grafica.labels_x[3],
                                graficaPorCandidatura.grafica.labels_x[1],
                                graficaPorCandidatura.grafica.labels_x[2],
                                graficaPorCandidatura.grafica.labels_x[4],
                                graficaPorCandidatura.grafica.labels_x[5]
                             ];
        
        let newOrdenSeries = [[
                                graficaPorCandidatura.grafica.series[1][0],
                                graficaPorCandidatura.grafica.series[1][3],
                                graficaPorCandidatura.grafica.series[1][1],
                                graficaPorCandidatura.grafica.series[1][2],
                                graficaPorCandidatura.grafica.series[1][4],
                                graficaPorCandidatura.grafica.series[1][5]
                             ],[
                                graficaPorCandidatura.grafica.series[0][0],
                                graficaPorCandidatura.grafica.series[0][3],
                                graficaPorCandidatura.grafica.series[0][1],
                                graficaPorCandidatura.grafica.series[0][2],
                                graficaPorCandidatura.grafica.series[0][4],
                                graficaPorCandidatura.grafica.series[0][5]
                             ]];
        
        let newOrdenColors = [
                                graficaPorCandidatura.grafica.colores_series[1],
                                graficaPorCandidatura.grafica.colores_series[0],
                             ];

        let newOrdenSerieLabels = [
                                graficaPorCandidatura.grafica.nombres_series[1],
                                graficaPorCandidatura.grafica.nombres_series[0],
                             ];

        let series = newOrdenSeries.map((data, index) => {
            const serie = {
                data: data,
                color: newOrdenColors[index]  // Asignamos el color correspondiente
            };
    
            // Si deshabilitarName es false, asignamos el nombre, de lo contrario lo omitimos
            if (!graficaPorCandidatura.grafica.deshabilitarName[index]) {
                serie.name = newOrdenSerieLabels[index]; // Asignamos el nombre a la serie
            }
    
            return serie;
        });

        let chartConfig = {
            title: {
                text: "Registro curricular por cargo", //graficaPorCandidatura.grafica.titulo,
            },
            xAxis: {
                categories: newOrdenLabels,
            },
            chart: {
                borderWidth: 0,  // Elimina el borde alrededor de la gráfica
                backgroundColor: '#F8FBFF !important',  // Establece el fondo transparente
            },
            legend: {
                enabled: true,  // Habilitamos la leyenda
                layout: 'horizontal',  // Esto asegura que los labels estén en una fila
                align: 'center',  // Centra la leyenda
                verticalAlign: 'top',  // Coloca la leyenda en la parte superior
                borderWidth: 0,  // Sin borde para la leyenda
                itemStyle: {
                    fontWeight: 'bold',  // Hace los nombres de la leyenda más prominentes
                    fontSize: '14px',  // Ajusta el tamaño de la fuente si es necesario
                },
            },
            tooltip: {
                backgroundColor: '#FFFFFF',  // Establece el fondo del tooltip a blanco
                shadow: true,  // Activa la sombra en el tooltip
                pointFormatter: function() {
                    return `<b>${this.y}%</b>`;  // Agrega un '%' al valor mostrado en el tooltip
                },
            },
            yAxis: {
                min: graficaPorCandidatura.grafica.minimo,
                max: graficaPorCandidatura.grafica.maximo?? 100,
                title: {
                    text: "Porcentaje",
                },
                //tickInterval: 20,
            },
            series: series,  // Usamos las series generadas dinámicamente
            credits: {
                enabled: false, // Esto desactiva la marca de agua de Highcharts
            },
        };

        await sleep(200); 

        Highcharts.chart('graficaDos', {
            ...chartConfig,
            chart: {
                type: 'column',  // Tipo de gráfico: barras
                renderTo: 'graficaDos',
            },
        });
    };

    const cambiarTab = (value) => {
        setSelectedKey(value);
    };

    const columnasUno = [
        {
            dataIndex: 'etiqueta',
            key: 'etiqueta',
        },
        {
            dataIndex: 'PEF',
            key: 'PEF',
        },
        {
            dataIndex: 'PLF',
            key: 'PLF',
        },
		{
            dataIndex: 'PJF',
            key: 'PJF',
        },
        {
            dataIndex: 'EF',
            key: 'EF',
        },
    ];

    const columnasDos = [
        {
            dataIndex: 'etiqueta',
            key: 'etiqueta',
        },
        {
            dataIndex: 'SupremaCorte',
            key: 'SupremaCorte',
        },
        {
            dataIndex: 'MagistraturaSS',
            key: 'MagistraturaSS',
        },
        {
            dataIndex: 'MagistraturaSR',
            key: 'MagistraturaSR',
        },
		{
            dataIndex: 'MagistraturaTDJ',
            key: 'MagistraturaTDJ',
        },
		{
            dataIndex: 'MagistraturaTCC',
            key: 'MagistraturaTCC',
        },
		{
            dataIndex: 'JuecesDistrito',
            key: 'JuecesDistrito',
        },
    ];

    return (
        <>
            <Row style={{ marginTop:"35px"}}>
                <Col style={{ color: "#D5007F", fontWeight: "bold", fontSize:"16px" }} >Estadísticas: </Col>
            </Row>
            <Row>
                <Col>Consulta las estadísticas del avance en la captura de las personas candidatas, clasificadas por poder y por cargo.</Col>
            </Row>
        
            <Row style={{backgroundColor:"#F8FBFF", marginTop:"20px"}}>
                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                    <Row style={{width: "100%"}}>
                        <Col id="tab1" xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} 
                            style={{
                                margin:"0px",
                                justifyContent: "center",
                                cursor: "pointer", 
                                backgroundColor: selectedKey == 1 ? "#D5007F" : "#FFFFFF",  // Cambia el fondo a rosa si es el tab seleccionado
                                transition: "background-color 0.3s ease",  // Añadir una transición suave
                                border: "1px solid",
                                borderColor: selectedKey == 1 ? "#D5007F" : "#707070",
                            }} 
                            onClick={() => cambiarTab(1)}>
                            <span style={{display: "flex", justifyContent: "center", padding: "8px",
                                    color: selectedKey == 1 ? "#FFFFFF" : "#000000"}}>
                                Registro curricular por poder
                            </span>
                        </Col>
                        <Col id="tab2" xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} 
                            style={{
                                margin:"0px",
                                justifyContent: "center",
                                cursor: "pointer", 
                                backgroundColor: selectedKey == 2 ? "#D5007F" : "#FFFFFF",  // Cambia el fondo a rosa si es el tab seleccionado
                                transition: "background-color 0.3s ease",  // Añadir una transición suave
                                border: "1px solid",
                                borderColor: selectedKey == 2 ? "#D5007F" : "#707070",
                            }} 
                            onClick={() => cambiarTab(2)}>
                            <span style={{display: "flex", justifyContent: "center", padding: "8px", 
                                    color: selectedKey == 2 ? "#FFFFFF" : "#000000"}}>
                                Registro curricular por cargo
                            </span>
                        </Col>
                    </Row>
                    <Row style={{width: "100%", marginTop:"20px"}}>
                        <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        {(Number(selectedKey) == 1) && (
                            <div style={{width: "100%"}}>
                                <Row style={{width: "100%", marginBottom:"20px"}}>
                                    <Col style={{justifyItems:"center",  width: '100%', marginLeft: "5%", marginRight: "5%"}}>
                                        <div id="graficaUno" className="grafica" style={{width: '100%'}}></div>
                                    </Col>
                                </Row>
                                <Row style={{width: "100%", marginBottom:"20px", overflowX: "auto", minWidth: "100%"}}>
                                    <Col style={{justifyItems:"center",  width: '80%', minWidth: "800px", marginLeft: "10%", marginRight: "10%",
                                        margin: '0 auto', 
                                        display: 'table', 
                                        border: '1px solid #707070', // Borde exterior
                                        borderRadius: '15px', // Esquinas redondeadas
                                        overflow: 'hidden', // Asegura que las esquinas redondeadas no se vean recortadas
                                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)' // Sombra
                                    }}>
                                       {graficaPorPoderes?.tabla && graficaPorPoderes.tabla.map((item, index) => (
                                            <Row
                                                key={item.etiqueta}
                                                style={{
                                                    display: 'flex',
                                                    padding: '10px 0',
                                                    backgroundColor: index === graficaPorPoderes.tabla.length - 1 ? '#431D6E' : 'transparent',
                                                    color: index === graficaPorPoderes.tabla.length - 1 ? 'white' : 'black',
                                                    width: '100%',
                                                    fontSize: '11px',
                                                    justifyContent: 'space-between' // Para que las columnas se alineen
                                                }}
                                            >
                                                <Col span={1} style={{ padding: '0',paddingLeft:"15px", paddingRight:"10px", textAlign: 'center', fontSize: '11px'}}>
                                                    {item.etiqueta}
                                                </Col>
                                                <Col span={4} style={{ padding: '0 ', textAlign: 'center', fontSize: '11px' }}>
                                                    {item.PEF}
                                                </Col>
                                                <Col span={4} style={{ padding: '0 ', textAlign: 'center', fontSize: '11px' }}>
                                                    {item.PLF}
                                                </Col>
                                                <Col span={4} style={{ padding: '0 ', textAlign: 'center', fontSize: '11px' }}>
                                                    {item.PJF}
                                                </Col>
                                                <Col span={4} style={{ padding: '0 ', marginRight: "10px", textAlign: 'center', fontSize: '11px' }}>
                                                    {item.EF}
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                                
                                <Row style={{width: "100%", marginBottom:"20px"}}>
                                    <Col style={{width: "80%", marginLeft: "10%", marginRight: "10%"}}>
                                        <span style={{marginTop: "30px", display:"flex", justifyContent:"right"}}>
                                            Última actualización: {moment(graficaPorPoderes.fecha).format("DD/MM/YYYY HH:mm [horas.]")}
                                        </span>
                                    </Col>
                                </Row>
                            </div>                    
                        )}

                        {(Number(selectedKey) == 2) && (
                            <div style={{width: '100%'}}>
                                <Row style={{width: "100%", marginBottom:"20px", overflowX: "auto", minWidth: "100%"}}>
                                    <Col style={{justifyItems:"center",  width: '100%',minWidth: "800px", marginLeft: "5%", marginRight: "5%"}}>
                                        <div id="graficaDos" className="grafica" style={{width: '100%'}}></div>
                                    </Col>
                                </Row>
                                <Row style={{width: "100%", marginBottom:"20px", overflowX: "auto", minWidth: "100%"}}>
                                    <Col style={{justifyItems:"center",  width: '80%', minWidth: "800px", marginLeft: "10%", marginRight: "10%",
                                        margin: '0 auto', 
                                        display: 'table', 
                                        border: '1px solid #707070', // Borde exterior
                                        borderRadius: '15px', // Esquinas redondeadas
                                        overflow: 'hidden', // Asegura que las esquinas redondeadas no se vean recortadas
                                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)' // Sombra
                                    }}>

                                        {graficaPorCandidatura?.tabla && graficaPorCandidatura.tabla.map((item, index) => (
                                        
                                        <Row
                                        key={item.etiqueta}
                                        style={{
                                            padding: '10px 0',
                                            backgroundColor: index === graficaPorCandidatura.tabla.length - 1 ? '#431D6E' : 'transparent',
                                            color: index === graficaPorCandidatura.tabla.length - 1 ? 'white' : 'black',
                                            width: '100%',
                                            justifyContent: 'space-between', // Para que las columnas se alineen
                                            fontSize: '11px', // Se aplica el tamaño de fuente de 11px
                                            fontFamily: 'Arial, sans-serif', // Puedes especificar la fuente si lo necesitas
                                        }}
                                    >
                                        <Col span={1} style={{ padding: '0', paddingLeft:"15px", paddingRight:"10px", textAlign: 'center', fontSize: '11px' }}>
                                            {item.etiqueta}
                                        </Col>
                                        <Col span={3} style={{ padding: '0', textAlign: 'center', fontSize: '11px' }}>
                                            {item.SupremaCorte}
                                        </Col>
                                        <Col span={3} style={{ padding: '0', textAlign: 'center', fontSize: '11px' }}>
                                            {item.MagistraturaTDJ}
                                        </Col>
                                        <Col span={3} style={{ padding: '0', textAlign: 'center', fontSize: '11px' }}>
                                            {item.MagistraturaSS}
                                        </Col>
                                        <Col span={3} style={{ padding: '0', textAlign: 'center', fontSize: '11px' }}>
                                            {item.MagistraturaSR}
                                        </Col>
                                        <Col span={3} style={{ padding: '0', textAlign: 'center', fontSize: '11px' }}>
                                            {item.MagistraturaTCC}
                                        </Col>
                                        <Col span={3} style={{ padding: '0', marginRight: "10px", textAlign: 'center', fontSize: '11px' }}>
                                            {item.JuecesDistrito}
                                        </Col>
                                    </Row>
                                        
                                        ))}
                                    </Col>
                                </Row>
                                <Row style={{width: "100%", marginBottom:"20px"}}>
                                    <Col style={{width: "80%", marginLeft: "10%", marginRight: "10%"}}>
                                        <span style={{marginTop: "30px", display:"flex", justifyContent:"right"}}>
                                            Última actualización {moment(graficaPorCandidatura.fecha).format("DD/MM/YYYY HH:mm:ss [hrs]")}
                                        </span>
                                    </Col>
                                </Row>
                            </div>         
                        )}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default GraficasPJ;